import { render } from "./CardView.vue?vue&type=template&id=15835da9"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"

import "./CardView.vue?vue&type=style&index=0&id=15835da9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__